var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon library/fi-rs-play-alt",
    clipPath: "url(#clip0_64_3387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0716 18.0714H0.928711V3.07145C0.928711 2.50312 1.15448 1.95808 1.55634 1.55622C1.9582 1.15435 2.50325 0.928589 3.07157 0.928589L15.9287 0.928589C16.497 0.928589 17.0421 1.15435 17.4439 1.55622C17.8458 1.95808 18.0716 2.50312 18.0716 3.07145V18.0714ZM2.35728 16.6429H16.643V3.07145C16.643 2.88201 16.5677 2.70032 16.4338 2.56637C16.2998 2.43242 16.1181 2.35716 15.9287 2.35716H3.07157C2.88213 2.35716 2.70045 2.43242 2.56649 2.56637C2.43254 2.70032 2.35728 2.88201 2.35728 3.07145V16.6429ZM6.643 13.5879V5.41216L13.7973 9.50002L6.643 13.5879ZM8.07157 7.87359V11.1264L10.9173 9.50002L8.07157 7.87359Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_3387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(0.928711 0.928589)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCounter);
export default __webpack_public_path__ + "static/media/video-counter.f5c04ec671d87d2051fc919c96a8fe34.svg";
export { ForwardRef as ReactComponent };